<template>
  <div class="regra-campo-editor">
    <div class="header-row" v-if="modoTrocaTipo">
      <span class="header-label">Tipo:</span>
      <button
        v-for="tipo in tiposDisponiveis"
        :key="tipo.value"
        type="button"
        class="tab-link"
        :class="{ 'tab-link--active': regraTipo === tipo.value }"
        @click="alterarTipo(tipo.value)"
      >
        <fa-icon :icon="tipo.icone" /> {{ tipo.label }}
      </button>
    </div>

    <div class="editor-body">
      <RegraCondicional
        v-if="regraTipo === 'condicional'"
        :value="value"
        :campos="campos"
        :operadores="operadores"
        :para-value="paraValue"
        :possui-campos-para="possuiCamposPara"
        :placeholder-para="placeholderPara"
        :mostrar-erros="mostrarErros"
        @input="onInput"
        @update:paraValue="$emit('update:paraValue', $event)"
        @selecionar-para="$emit('selecionar-para', $event)"
      />
      <RegraCoalesce
        v-else-if="regraTipo === 'coalesce'"
        :value="value"
        :campos="campos"
        @input="onInput"
      />
      <RegraConcatenacao
        v-else-if="regraTipo === 'concatenacao'"
        :value="value"
        :campos="campos"
        @input="onInput"
      />
      <RegraMapeamento
        v-else-if="regraTipo === 'mapeamento'"
        :value="value"
        :campos="campos"
        @input="onInput"
      />

      <TestadorRegra
        v-if="value && value.tipo"
        :regra="value"
        :exemplos="exemplosTeste"
      />
    </div>
  </div>
</template>

<script>
import RegraCondicional, { regraCondicionalVazia } from "./regra/RegraCondicional";
import RegraCoalesce, { regraCoalesceVazia } from "./regra/RegraCoalesce";
import RegraConcatenacao, { regraConcatenacaoVazia } from "./regra/RegraConcatenacao";
import RegraMapeamento, { regraMapeamentoVazia } from "./regra/RegraMapeamento";
import TestadorRegra from "./regra/TestadorRegra";

const FACTORIES = {
  condicional: regraCondicionalVazia,
  coalesce: regraCoalesceVazia,
  concatenacao: regraConcatenacaoVazia,
  mapeamento: regraMapeamentoVazia,
};

export const novaRegra = (tipo = "condicional") => FACTORIES[tipo]();

export default {
  name: "RegraCampoEditor",
  components: { RegraCondicional, RegraCoalesce, RegraConcatenacao, RegraMapeamento, TestadorRegra },
  props: {
    value: { type: Object, required: true },
    campos: { type: Array, default: () => [] },
    operadores: { type: Array, default: () => [] },
    modoTrocaTipo: { type: Boolean, default: false },
    paraValue: { type: String, default: "" },
    possuiCamposPara: { type: Boolean, default: false },
    placeholderPara: { type: String, default: "Campo de destino" },
    mostrarErros: { type: Boolean, default: false },
    exemplosTeste: { type: Array, default: () => [] },
  },
  computed: {
    regraTipo() {
      return this.value && this.value.tipo;
    },
    tiposDisponiveis() {
      return [
        { value: "mapeamento",   label: "Mapeamento",   icone: "table" },
        { value: "concatenacao", label: "Concatenação", icone: "link" },
        { value: "coalesce",     label: "1º disponível", icone: "list-ol" },
        { value: "condicional",  label: "Condicional",  icone: "code-branch" },
      ];
    },
  },
  methods: {
    alterarTipo(tipo) {
      if (tipo === this.regraTipo) return;
      this.$emit("input", FACTORIES[tipo]());
    },
    onInput(novo) {
      this.$emit("input", novo);
    },
  },
};
</script>

<style scoped>
.regra-campo-editor {
  background: #fff;
}
.header-row {
  display: flex;
  align-items: center;
  gap: 6px;
  margin-bottom: 12px;
  padding-bottom: 10px;
  border-bottom: 1px dashed var(--border-default);
}
.header-label {
  font-size: 12px;
  color: var(--text-muted);
  margin-right: 4px;
}
.tab-link {
  background: none;
  border: none;
  color: var(--text-subtle);
  font-size: 12px;
  padding: 3px 8px;
  border-radius: 4px;
  cursor: pointer;
  transition: all 0.15s;
}
.tab-link:hover {
  background: var(--primary-hover-bg);
  color: var(--primary);
}
.tab-link--active {
  color: var(--primary);
  background: #eceaf3;
  font-weight: 600;
}
.editor-body {
  padding-top: 4px;
}
</style>
